import { reduxActions } from '../constants';

const defaultAppState = {
    currentRoute: '/'
}

export function appState(state = defaultAppState, action) {
    switch (action.type) {
        case reduxActions.STATE_CHANGE:
        return Object.assign({}, state, {
            currentRoute: action.route
        });
        default:
        return state
    }
}



// WEBPACK FOOTER //
// ./web-app/reducers/route-reducer.js